export default __webpack_public_path__ + "6070eb7c13b13fe22fc4eeea3a389c57.woff";